import { App } from '../app.class';
import { Modal } from '../modal.class';
import { Notification } from '../notification.class';
import { Mailaddresses } from '../mailaddresses.class';
import { Fetch } from '../../fetch.class';

export class Page {

    constructor() {

        // Formular-Code
        this.$formCode = document.querySelector('header .form_code');
        this.form_code = this.$formCode.textContent;

        // Basis-URL zu Prozessor
        this.baseUrl = App.getUrl('form-delivery')+"/"+this.form_code+"/mailing";


        // --- Empfängeradressen
        new Mailaddresses('#mailaddresses', 'form', this.form_code);


        // --- Antwortadresse

        // Elemente
        this.$btnEditReplyto = document.querySelector('button.replyto');
        this.$inputEditReplyto = document.querySelector('#modal-edit-replyto input[name=replyto]');
        this.$displayReplyto = document.querySelector('#value_replyto');
        this.$displayReplytoEmpty = document.querySelector('#value_replyto_empty');
        this.$formEditReplyto = document.querySelector('#modal-edit-replyto form');
        this.$errorboxEditReplyto = document.querySelector('#modal-edit-replyto .errorbox');

        // Modal
        this.modalEditReplyto = new Modal('#modal-edit-replyto');

        // Modaldialog öffnen
        this.$btnEditReplyto.addEventListener('click', event => {

            // Fehlermeldung ausblenden
            this.$errorboxEditReplyto.classList.add('hidden');

            // Modal öffnen
            this.modalEditReplyto.show();
        });

        // Speicherung
        this.$formEditReplyto.addEventListener('submit', event => {

            event.preventDefault();

            const data = new FormData();
            data.append("replyto", this.$inputEditReplyto.value);

            // Fehler ausblenden
            this.$errorboxEditReplyto.classList.add('hidden');

            // Senden
            new Fetch().post(this.baseUrl+'/save_replyto', data)
            .then(response => {

                // Modal schliessen
                this.modalEditReplyto.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // in Anzeige übernehmen
                if(this.$inputEditReplyto.value.trim() == '') {
                    this.$displayReplyto.classList.add('hidden');
                    this.$displayReplytoEmpty.classList.remove('hidden');
                }
                else {
                    this.$displayReplyto.classList.remove('hidden');
                    this.$displayReplytoEmpty.classList.add('hidden');
                    this.$displayReplyto.textContent = this.$inputEditReplyto.value;
                }
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxEditReplyto.querySelector('.cont').textContent = error.message;
                this.$errorboxEditReplyto.classList.remove('hidden');
            });
        });


        // --- Betreff

        // Elemente
        this.$btnEditSubject = document.querySelector('button.subject');
        this.$inputEditSubject = document.querySelector('#modal-edit-subject input[name=subject]');
        this.$displaySubject = document.querySelector('#value_subject');
        this.$displaySubjectEmpty = document.querySelector('#value_subject_empty');
        this.$formEditSubject = document.querySelector('#modal-edit-subject form');
        this.$errorboxEditSubject = document.querySelector('#modal-edit-subject .errorbox');

        // Modal
        this.modalEditSubject = new Modal('#modal-edit-subject');

        // Modaldialog öffnen
        this.$btnEditSubject.addEventListener('click', event => {

            // Fehlermeldung ausblenden
            this.$errorboxEditSubject.classList.add('hidden');

            // Modal öffnen
            this.modalEditSubject.show();
        });

        // Speicherung
        this.$formEditSubject.addEventListener('submit', event => {

            event.preventDefault();

            const data = new FormData();
            data.append("subject", this.$inputEditSubject.value);

            // Fehler ausblenden
            this.$errorboxEditSubject.classList.add('hidden');

            // Senden
            new Fetch().post(this.baseUrl+'/save_subject', data)
            .then(response => {

                // Modal schliessen
                this.modalEditSubject.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // in Anzeige übernehmen
                if(this.$inputEditSubject.value.trim() == '') {
                    this.$displaySubject.classList.add('hidden');
                    this.$displaySubjectEmpty.classList.remove('hidden');
                }
                else {
                    this.$displaySubject.classList.remove('hidden');
                    this.$displaySubjectEmpty.classList.add('hidden');
                    this.$displaySubject.textContent = this.$inputEditSubject.value;
                }
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxEditSubject.querySelector('.cont').textContent = error.message;
                this.$errorboxEditSubject.classList.remove('hidden');
            });
        });
    }
}

// Initialisierung wenn DOM geladen
App.domready(()=>{
    if(document.querySelector('body').classList.contains('form-delivery-mailing')) {
        new Page();
    }
});